export default __webpack_public_path__ + "static/media/mountain-8.c48d9429.png";